import Modal, { ModalProps } from "@timeedit/ui-components/antd/modal/index";
import { useEffect, useState } from "react";
import { Select } from "@timeedit/ui-components/antd";
import Language from "../../lib/Language";
import { TOrganizationInView } from "../../models/View";

type TOrganizationPromptModalProps = {
    onSelectOrganization: (organization: TOrganizationInView) => void;
    onCancel: () => void;
    organizations: TOrganizationInView[];
    open: boolean;
    title: string;
} & ModalProps;

const OrganizationPromptModal: React.FC<TOrganizationPromptModalProps> = ({
    onSelectOrganization,
    onCancel,
    organizations,
    open,
    title,
}) => {
    const [selectedId, setSelectedId] = useState<number | undefined>(undefined);

    useEffect(() => {
        setSelectedId(undefined);
    }, [open]);

    const options = [...organizations]
        .sort((a, b) => a.extid.localeCompare(b.extid))
        .map((organization) => ({ value: organization.id, label: organization.extid }));

    const onOk = () => {
        const organization = organizations.find((org) => org.id === selectedId);
        if (organization) {
            onSelectOrganization(organization);
        }
    };

    return (
        <Modal
            open={open}
            title={title}
            okText={Language.get("dialog_save")}
            cancelText={Language.get("dialog_cancel")}
            onOk={onOk}
            okButtonProps={{ disabled: selectedId === undefined }}
            onCancel={onCancel}
        >
            <Select
                autoFocus
                style={{ width: "100%" }}
                placeholder={Language.get("user_pane_organization")}
                value={selectedId}
                onChange={(value: number) => setSelectedId(value)}
                options={options}
                showSearch={{ optionFilterProp: "label" }}
            />
        </Modal>
    );
};

export default OrganizationPromptModal;
